package utils

import kotlinx.serialization.*
import kotlinx.serialization.json.*
import kotlinx.serialization.protobuf.*

object ObjectMapper {

    val json = Json { ignoreUnknownKeys = true }
    val proto = ProtoBuf

    inline fun <reified T> writeAsByteArray(value: T): ByteArray = proto.encodeToByteArray(value)
    inline fun <reified T> parseBytes(bytes: ByteArray): T = proto.decodeFromByteArray(bytes)

}
